import React from 'react';

export default class SettingsIndex extends React.Component {
  componentDidMount() {
    this.props.router.replace('/settings/general');
  }

  render() {
    return null;
  }
}
